import React from "react";
import { FaSearch,FaTimes } from 'react-icons/fa';
//width: 200px;
import styled from "styled-components";
const Input = styled.input.attrs(props => ({
  type: "text",
  size: props.small ? 5 : undefined
}))`
  height: 32px;
  width:95%;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;
`;
//  display: flex;
const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 32px;
  width: 32px;
  text-align: center;
  border: 1px solid #e5e5e5;
  align-items: center;
  justify-content: center;

`;

const SearchButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 32px;
  width: 32px;
  text-align: center;
  border: 1px solid #e5e5e5;
  align-items: center;
  justify-content: center;

`;
//
const FilterComponent = ({ filterText, onFilter, onClear,onSearch,search }) => (
  <>
  <div className='d-flex'>
    <Input
      id="search"
      type="text"
      placeholder="Filter table data..."
      value={filterText}
      onChange={onFilter}
      className='w-100'
    />
  {(search!==""?
    <ClearButton onClick={onClear}><FaTimes /></ClearButton>
  :
    < SearchButton onClick={onSearch}><FaSearch /></SearchButton>
  )}
  </div>
   
   
  </>
);

export default FilterComponent;
